// Menú fijo de la kermés. Si más adelante vendes más de dos productos,
// esto es lo primero que hay que cambiar por un catálogo dinámico
// (traído del backend en vez de hardcodeado aquí).
export const PRODUCT_IDS = {
  PANUCHOS: 1,
  SALBUTES: 2,
};

export const PRODUCT_NAMES = {
  [PRODUCT_IDS.PANUCHOS]: "Panuchos",
  [PRODUCT_IDS.SALBUTES]: "Salbutes",
};

export const STATUS_CONFIG = {
  pending: { label: "Pendiente", color: "gold" },
  delivered: { label: "Entregado", color: "green" },
  cancelled: { label: "Cancelado", color: "red" },
};
